// Contains stores of all List and Edit components keyed with their name.
export const storesMap = new Map();
